import styled from 'styled-components';
import { profileImage } from '../../../contants';
import { motion } from 'framer-motion';
import { useTheme } from '../../../context/ThemeContext';

const lightTheme = {
  primaryColor: 'hsl(0, 24%, 30%)',
  secondaryColor: 'hsl(0, 24%, 85%)',
  tertiaryColor: 'hsl(0, 24%, 60%)',
  highlightColor: 'hsl(23, 91%, 52%)',
};

const darkTheme = {
  primaryColor: 'hsl(0, 24%, 100%)',
  secondaryColor: 'hsl(0, 4%, 65%)',
  tertiaryColor: 'hsl(0, 4%, 60%)',
  highlightColor: 'hsl(23, 91%, 52%)',
};

const ProfileTile = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const theme = isDarkMode ? darkTheme : lightTheme;

  return (
    <ProfileWrapper>
      <ProfileSummary>
        <Content textColor={theme.secondaryColor}>Hi, I'm </Content>
        <ProfileImageContainer onClick={toggleTheme}>
          <ProfileImage src={profileImage} />
        </ProfileImageContainer>
        <Content textColor={theme.primaryColor}>Parth Hingu!</Content>
        <p>
          <Content textColor={theme.secondaryColor}>I'm a </Content>
          <Content textColor={theme.primaryColor}>Front-End developer </Content>
          <Content textColor={theme.secondaryColor}>crafting </Content>
          <Content textColor={theme.highlightColor}>
            single web applications.
          </Content>
        </p>
      </ProfileSummary>
      <ProfileImageWrapper>
        <OpenToWork>
          <DotContainer
            as={motion.div}
            animate={{
              scale: [0.9, 1.1, 0.9], // Pulse from normal size to 1.3x and back
              opacity: [1, 0.5, 1], // Fade effect during pulse
            }}
            transition={{
              duration: 1.5, // Animation duration
              repeat: Infinity, // Infinite looping
              ease: 'easeInOut', // Smooth easing
            }}
          >
            <InnerDotContainer
              as={motion.div}
              animate={{
                opacity: [1, 0.5, 1], // Fade effect during pulse
              }}
              transition={{
                duration: 1.5, // Animation duration
                repeat: Infinity, // Infinite looping
                ease: 'easeInOut', // Smooth easing
              }}
            />
          </DotContainer>
          <span>Open to Work</span>
        </OpenToWork>
      </ProfileImageWrapper>
    </ProfileWrapper>
  );
};

const Content = styled.span`
  color: ${({ textColor }) => textColor};
`;

const ProfileImageContainer = styled.span`
  position: relative;
  cursor: pointer;
`;

const DotContainer = styled.div`
  position: relative;
  width: 18%;
  height: 100%;
  background-color: hsla(120, 100%, 74%, 0.5); /* Outer dot color */
  border-radius: 50%; /* Makes it circular */
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 500px) {
    width: 20%;
    height: 80%;
  }
`;

const InnerDotContainer = styled.div`
  position: absolute;
  width: 50%;
  height: 50%;
  background-color: hsla(120, 100%, 50%, 1); /* Inner dot color */
  border-radius: 50%;
`;

const OpenToWork = styled.button`
  height: 30px;
  width: 120px;
  text-align: right;
  padding: 5px 6px;
  background-color: ${({ theme }) => theme.tileBackground};
  margin-top: 16px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  display: flex;
  align-items: center;
  gap: 6px;

  span {
    color: ${({ theme }) => theme.text};
    font-size: 12px;
    font-weight: 500;
  }
  @media (max-width: 500px) {
    gap: 5px;
    width: 120px;
    height: 36px;
    font-size: 10px;
    padding: 3px 6px;
    margin-left: -40px;
    margin-top: 16px;
    filter: drop-shadow(0.05rem 0.1rem 0.1rem rgba(0, 0, 0, 0.05));
  }
`;

const ProfileWrapper = styled.div`
  height: 100%;
  display: flex;
  padding: 24px 40px 16px 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  position: relative;

  @media (max-width: 500px) {
    padding: 16px 20px;
    align-items: center;
    gap: 16px;
  }
`;

const ProfileImage = styled.img`
  border-radius: 32px;
  object-fit: cover;
  margin: 0 8px;
  height: 100px;
  width: 100px;
  border: 3px solid ${({ theme }) => theme.borderColor};
  margin-bottom: 20px;
  @media (max-width: 500px) {
    margin-bottom: 30px;
  }
`;

const ProfileImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  position: absolute;
  right: 28px;
  top: 8px;
  width: 100%;
  @media (max-width: 500px) {
    justify-content: end;
    margin-left: 50px;
    right: 16px;
    top: -10px;
  }
`;

const ProfileSummary = styled.p`
  font-size: 2rem;
  font-weight: 600;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  text-align: left;
  span {
    line-height: 60px;
  }
  p {
    margin-top: -38px;
  }

  @media (max-width: 500px) {
    font-size: 1.2rem;
    font-weight: 600;
    span {
      line-height: 50px;
    }
    p {
      margin-top: -46px;
    }
  }
`;

export default ProfileTile;
